import { Logo } from "@/components/Logo";

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="grid min-h-screen bg-[#0a0a0c] lg:grid-cols-2">
    <div className="relative hidden overflow-hidden lg:block">
      <img src="/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-[#0a0a0c]/40 to-[#0a0a0c]/30" />
      <p className="absolute bottom-12 left-12 max-w-sm font-serif text-3xl italic text-amber-50">"Discretion, punctuality, and a car that's already waiting."</p>
    </div>
    <div className="flex flex-col px-5 py-8 sm:px-12">
      <Logo />
      <div className="mx-auto my-auto w-full max-w-md py-12 fade-up">
        <h1 className="text-3xl font-semibold text-amber-50 sm:text-4xl">{title}</h1>
        <p className="mt-3 text-sm text-zinc-400">{subtitle}</p>
        <div className="mt-10">{children}</div>
      </div>
    </div>
  </div>
);

export const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="lux-eyebrow mb-2 block">{label}</span>
    <input className="lux-input" {...props} />
  </label>
);
